export enum PublishPageAsBlogSources {
	ViewPage = 'VIEW_PAGE',
	EditPage = 'EDIT_PAGE',
}
